/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useEffect, useState} from "react";
import {service as SpeciesListService} from "../../../Services/SpeciesListService";
import {useEffectPromise} from "../../../Hooks/EffectHooks";

export const SpeciesRequestSpeciesListsFieldViewer = (props) => {
	const {speciesRequestSpeciesLists} = props;
	const [customListDescription, setCustomListDescription] = useState(null);

	const updateCustomListDescription = async () => {
		let result = '';
		try {
			result = (await Promise.all(
					speciesRequestSpeciesLists?.map(
						(speciesList) => SpeciesListService.TitleById(speciesList.speciesListId)
					) ?? []
				))?.join(', ');
		} catch(e) {
			result = '';
		}
		return result;
	}

	useEffectPromise(
		updateCustomListDescription,
		setCustomListDescription,
		[JSON.stringify(speciesRequestSpeciesLists)]
	);
	
	return <div>{customListDescription === '' ? '(None Specified)' : customListDescription}</div>
};